export const title = {
  cn: "CQ9 游戏大厅",
  en: "CQ9 Game Lobby",
  th: "CQ9 เกมล็อบบี้",
  vn: "Sảnh Game CQ9",
}
